import { CheckBadgeIcon, PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Tooltip from "@/common/tooltip/Tooltip";
import SmartPensionEmployeeLink from "@/integrations/smartPension/SmartPensionEmployeeLink";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Actions as INTEGRATION_ACTIONS } from "../../../store/actions/integrationActions";
import { Actions as EMPLOYEE_ACTIONS } from "../../../store/actions/employeeActions";
import { NotificationManager } from "react-notifications";

const PensionIntegrationsModal = ({ links, linkEmployee, getEmployeeDetails }) => {
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (!isOpen) return;

		if (!links[0]?.agreement) {
			setIsOpen(false);
			return NotificationManager.error("Unable to find employee...", "Integration Links");
		}
		getEmployeeDetails(links[0]?.agreement);
	}, [isOpen]);

	const saveChanges = () => {
		if (!links[0]?.agreement) return NotificationManager.error("Unable to save changes...", "Integration Links");

		linkEmployee();
		NotificationManager.success("Integration Links Updated Sucessfully!", "Integration Links");
	};
	return (
		<>
			<button
				type="button"
				className="btn btn-xs btn-default"
				onClick={() => setIsOpen(true)}
			>
				<Tooltip content="Edit Links">
					<PencilSquareIcon
						className="h-5 w-5 text-dark-gray"
						style={{ marginTop: "3px" }}
					/>
				</Tooltip>
			</button>
			<div
				className="modal"
				tabIndex="-1"
				role="dialog"
				ariaHidden={!isOpen}
				style={{
					visibility: isOpen ? "visible" : "hidden",
					display: "block",
					background: "rgba(0, 0, 0, 0.4)",
					overflow: "scroll",
					transition: "opacity 0.5s ease-in-out, visibility 0.5s ease-in-out",
					opacity: isOpen ? 1 : 0,
					pointerEvents: isOpen ? "auto" : "none",
					textAlign: "left",
				}}
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="block block-themed block-transparent remove-margin-b p-0">
							<div className="block-header bg-primary-dark p-5">
								<ul className="block-options">
									<li>
										<button
											type="button"
											onClick={() => setIsOpen(false)}
										>
											<XMarkIcon className="h-6 w-6 mr-3 text-white" />
										</button>
									</li>
								</ul>
								<h3 className="block-title text-white">Integration Links</h3>
							</div>
							<div className="block-content p-5 mt-5">
								{links.map((link) => {
									const agreementInfo = { id: link?.agreement };
									const size = 6;

									switch (link?.type) {
										case "Smart Pension":
											return <SmartPensionEmployeeLink {...{ agreementInfo, size }} />;
									}
								})}
								<div className="clearfix" />
							</div>
							<div className="col-xs-12 mb-2">
								<button
									className="btn btn-success pull-right ml-2"
									onClick={() => saveChanges()}
								>
									<CheckBadgeIcon style={{ height: "1.5em", float: "left" }} />
									<span style={{ float: "left", marginLeft: 5 }}>Save</span>
								</button>
								<button
									className="btn btn-danger pull-right"
									onClick={() => setIsOpen(false)}
								>
									Cancel
								</button>
							</div>
							<div className="clearfix" />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({
	linkEmployee: () => dispatch(INTEGRATION_ACTIONS.linkEmployee()),
	getEmployeeDetails: (agreementId) => dispatch(EMPLOYEE_ACTIONS.getEmployeeDetails(agreementId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PensionIntegrationsModal);
